/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {TemplateTextFormComponent as ɵc} from './templatetext-form/templatetext-form.component';
export {TemplateTextComponent as ɵb} from './templatetext.component';
export {declaration as ɵa} from './templatetext.module';
export {TemplateTextRoutes as ɵd} from './templatetext.routing';